<template>
  <section class="projects">
    <Container>
      <Title tag="h2" class="is-centered">Boletines</Title>
      <Row>
        <ColumnUi md="4" v-for="(project, index) in projects" :key="index">
          <SingleCard
            :title="project.title"
            icon="folder"
            :routePath="`/publicaciones/boletines/${project.slug}`"
          />
        </ColumnUi>
      </Row>
    </Container>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container";
import Row from "../ui/atoms/Row.vue";
import ColumnUi from "../ui/atoms/ColumnUi.vue";
import Title from "../ui/atoms/Title.vue";
import { getNewsletters } from "@/newsletter.js";
import SingleCard from "./SingleCard.vue";
export default {
  components: {
    Container,
    Row,
    ColumnUi,
    Title,
    SingleCard
  },
  setup() {
    const projects = getNewsletters(process.env.VUE_APP_PREFIX);
    return {
      projects
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.projects {
  padding: variables.$spacing-l 0;
}
</style>
